export default __webpack_public_path__ + "static/media/xbox-black.3e571847.png";